import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBars,
    faHouse,
    faRightFromBracket,
    faClock,
    faCircleExclamation,
    faBank,
    faPlus,
    faUsers,
    faChartSimple,
    faStopwatch,
    faList,
    faClockRotateLeft
} from "@fortawesome/free-solid-svg-icons";
import logoPD from '../../assets/logoPD.png';
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';
import toast, { Toaster } from 'react-hot-toast';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import MailIcon from '@mui/icons-material/Mail';
import inviteMemberLogo from '../../assets/inviteMember.png';
import { useData } from "./MemberData";
import axios from "axios";
import '../../styles/style.css';

interface Member{
  user_id: number;
  full_name: string;
  callsign: number;
  entry_date: string | Date;
  last_up: string | Date;
  discordID: string;
  functions?: Record<string, boolean | string>;
  certificates?: Record<string, boolean | string>;
  fw: number;
  notes: string;
  grade: string;
  adminLevel: number;
  concediu: number;
  reintegrated: boolean;
  email: string;
}

interface OpenDuties {
  callsign: number;
  start_clock: Date;
  status: string;
  type: string;
  inTest: string;
}

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

const Sidebar = ({ setCurrentPage }: { setCurrentPage: (page: string) => void }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isConducere, setIsConducere] = useState(false);
  const [isConducere2, setIsConducere2] = useState(false);
  const [isHR, setIsHR] = useState(false);
  const { allMembersData, getPoliceMemberInfo, getPenMemberInfo } = useData();
  const [dutyModalOpen, setDutyModalOpen] = useState(false);
  const [regularCallsigns, setRegularCallsigns] = useState<Member[]>([]);
  const [HRCallsigns, setHRCallsigns] = useState<Member[]>([]);
  const [activeCops, setActiveCops] = useState<Member[]>([]);
  const [activePen, setActivePen] = useState<Member[]>([]);
  const [allDutyOpen, setAllDutyOpen] = useState(false);
  const [openDuties, setOpenDuties] = useState<OpenDuties[]>([]);
  const [myDiscordID, setMyDiscordID] = useState('');
  const [activeDutyType, setActiveDutyType] = useState<string>('');

  useEffect(() => {
    const idFromCookies = Cookies.get('myDiscordID') || '';
    setMyDiscordID(idFromCookies);
  }, []);


  useEffect(() => {
    let isConducereTemp = false;
    let isConducere2Temp = false;
    let isHRTemp = false;
    let myDiscordID = Cookies.get('myDiscordID') || '';
    for (let index = 0; index < allMembersData.length; index++) {
      const member = allMembersData[index];
      if (member.grade === "COMISAR" || member.grade === "COMISAR-SEF" || member.grade === "CHESTOR-GENERAL") {
        if (member.discordID === myDiscordID) {
          isConducereTemp = true;
        }
      }
      if (member.grade === "SUB-INSPECTOR" || member.grade === "INSPECTOR" || member.grade === "INSPECTOR-PRINCIPAL" || member.grade === "SUB-COMISAR" || member.grade === "COMISAR" || member.grade === "COMISAR-SEF" || member.grade === "CHESTOR-GENERAL") {
        if (member.discordID === myDiscordID) {
          isConducere2Temp = true;
        }
      }
      if (member.functions) {
        if (JSON.parse(JSON.stringify(member.functions))['resurse umane'] === true && member.discordID === myDiscordID) {
          isHRTemp = true;
        }
      }
    }
    setIsHR(isHRTemp);
    setIsConducere(isConducereTemp);
    setIsConducere2(isConducere2Temp);
  }, [allMembersData]);

  const toggleSidebar = () => {
    setIsExpanded((prev) => !prev);
  };

  const menuItems = [
    { icon: faHouse, label: "Acasă", page: "home" },
    { icon: faUsers, label: "Membrii", page: "members" },
    { icon: faClock, label: "Activitate", page: "activity" },
    { icon: faClockRotateLeft, label: "Cooldown-uri", page: "cooldowns" }
  ];

  const menuItems2 = [
    { icon: faCircleExclamation, label: "Sancțiuni", page: "punishmentsList" },
    { icon: faChartSimple, label: "Statistici", page: "stats" }
  ]

  async function logOutUser() {
    Cookies.remove('accountCreated');
    Cookies.remove('myDiscordID');
    Cookies.remove('phpMyAdmin');
    Cookies.remove('username');
    Cookies.remove('userid');
    localStorage.removeItem("token");
    navigate("/");
  }

  const [open, setOpen] = useState(false);
  const [sendToMail, setToMail] = useState(null);

  const handleClose = () => {
    setOpen(false)
  };
  
  const activeDutyStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '60%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 4,
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '27%',
    height: '40%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#202020',
    boxShadow: '0 0px 20px rgba(255,255,255,0.3)', 
    borderRadius: '.5vw',
    outline: 'none',
    p: 4,
  };

  function handleChangeMail(e: any) {
    setToMail(e.target.value);
  }

  function isValidEmail(email: any) { 
    const gmailOrYahooRegex = /@(gmail|yahoo)\.com$/i;
    const atSymbolRegex = /@/;
    return gmailOrYahooRegex.test(email) && atSymbolRegex.test(email); 
  }

  const sendEmail = async () => { 
    const email = sendToMail
    if (isValidEmail(email)) {
      try {
        await makeAuthenticatedRequest(`${API_URL}/api/create-token`, {
          email: email,
          discordID: myDiscordID,
        });
        toast.success("Token creat cu succes!")
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Token-ul nu a fost creat.")
          return;
        }
      }
    } else {
      toast.error("Email invalid!")
    }
  };

  const dutyStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '55%',
    height: '70%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#202020',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 4,
  };

  const openDutys = async () => {
    try {
      const response = await axios.get(`${API_URL}/activity/getActiveDuties?type=pol`);
      if (response && response.data) {
        const data = response.data;
        const membersData = await axios.get(`${API_URL}/api/getPoliceData`, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}});
        if (membersData && membersData.data) {
          const members: Member[] = membersData.data;
          const matchedMembers = members.filter((member) => {
            return data.some((d: any) => d.callsign === member.callsign);
          });
          setActiveCops(matchedMembers)
        }
      }
      const response2 = await axios.get(`${API_URL}/activity/getActiveDuties?type=pen`);
      if (response2 && response2.data) {
        const data = response2.data;
        const membersData = await axios.get(`${API_URL}/api/getPenitenciarData`, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}});
        if (membersData && membersData.data) {
          const members: Member[] = membersData.data;
          const matchedMembers = members.filter((member) => {
            return data.some((d: any) => d.callsign === member.callsign);
          });
          setActivePen(matchedMembers)
        }
      }
    } catch (error) {
      toast.error("A apărut o eroare! Lista cu membrii nu a putut fi încărcată.");
      console.log(error);
    }
    setDutyModalOpen(true);
  }

  const showActivityData = async (depType: string, certType: string, type: string, hrAcces: string) => {
    try {
      const response = await axios.get(`${API_URL}/activity/getActiveDuties?type=${depType}`);
      if (response && response.data) {
        const data = response.data;
  
        const membersData = await axios.get(`${API_URL}/api/getPoliceData`, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}});
        if (membersData && membersData.data) {
          const members: Member[] = membersData.data;
  
          const filteredMembers = members.filter((member) => {
            let hasFunction = false;
            let hasCertificates = false;
            if (certType === "functions") {
              const functions = member.functions && JSON.parse(JSON.parse(JSON.stringify(member.functions)));
              hasFunction = functions && functions[type] === true;
            } else {
              const certificates = member.certificates && JSON.parse(JSON.parse(JSON.stringify(member.certificates)));
              hasCertificates = certificates && certificates[type] === true;
            }
            const hasMatchingCallsign = data.some((d: any) => d.callsign === member.callsign);
            if (certType === "functions") {
              return hasFunction && hasMatchingCallsign;
            } else {
              return hasCertificates && hasMatchingCallsign;
            }
          });
          toast.success("Callsign-urile au fost extrase cu succes!");
          if (hrAcces === "regular") {
            setRegularCallsigns(filteredMembers);
          } else {
            setHRCallsigns(filteredMembers);
          }
        }
      }
    } catch (error) {
      toast.error("A apărut o eroare!");
      console.log(error);
    }
  }

  function countCops(type: string, value: string) {
    let count = 0;
    for (let index = 0; index < activeCops.length; index++) {
      const member = activeCops[index];
      if (type === "functions") {
        if (member.functions && JSON.parse(JSON.parse(JSON.stringify(member.functions)))[value] === true) {
          count++;
        }
      } else {
        if (value === "high-speed") {
          if (member.certificates && (JSON.parse(JSON.parse(JSON.stringify(member.certificates)))['HS Incepator'] === true || JSON.parse(JSON.parse(JSON.stringify(member.certificates)))['HS Avansat'] === true)) {
            count++;
          }
        }
      }
    }
    return count;
  }

  const handleCloseDutyModal = () => {
    setDutyModalOpen(false);
  }

  const handleAllDutyClose = () => {
    setAllDutyOpen(false);
  }

  const openDutyModal = async (depType: string) => {
    setActiveDutyType(depType);
    try {
      const response = await axios.get(`${API_URL}/activity/getActiveDuties?type=${depType}`);
      if (response && response.data) {
        let newTable: OpenDuties[] = [];
        for (let index: number = 0; index < response.data.length; index++) {
          const element: OpenDuties = response.data[index];
          if (element.status === "running") {
            newTable.push(element);
          }
        }
        setOpenDuties(newTable);
      }
      setAllDutyOpen(true)
    } catch (err) {
      console.log(err);
      toast.error("A apărut o eroare! Lista cu pontajele active nu a putut fi încărcată.")
    }
  }

  const cancelDuty = async (callsign: number, type: string) => {
    let reasonInput;
    reasonInput = prompt("Introdu motivul anulării pontajului");
    if (reasonInput) {
      try {
        await makeAuthenticatedRequest(`${API_URL}/activity/cancelDuty`, {
          callsign: callsign,
          type: type,
          myDiscord: myDiscordID,
          full_name: type === "pol" ? getPoliceMemberInfo(callsign, "full_name") : getPenMemberInfo(callsign, "full_name"),
          discordID: type === "pol" ? getPoliceMemberInfo(callsign, "discordID") : getPenMemberInfo(callsign, "discordID"),
          reasonInput: reasonInput
        })
        openDutyModal(activeDutyType);
        openDutys();
        toast.success("Pontaj anulat cu succes!");
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Pontajul nu a fost anulat.");
        }
      }
    } else {
      toast.error("A apărut o eroare! Pontajul nu a fost anulat.");
    }
  };

  const checkJaf = (activeCops: Member[]) => { 
    let count = 0;
    for (let index = 0; index < activeCops.length; index++) {
      const member = activeCops[index];
      if (member.grade !== "CADET") {
        count++;
      }
    }
    return count;
  }

  return (
    <div
      className={`${
        isExpanded ? "w-[15%]" : "w-[8%]"
      } h-full flex flex-col items-center transition-all duration-300`}
    >
      <div className="w-full h-[10%] flex items-center justify-center">
        <img
          src={logoPD}
          alt="Logo Poliție"
          className={`mt-[10%] ${
            isExpanded ? "w-[40%]" : "w-[45%]"
          } transition-all duration-300`}
        />
      </div>

      <div className="w-full h-[75%] mt-[15%] flex flex-col items-center gap-[1%]">
        <div
          onClick={toggleSidebar}
          className={`${
            isExpanded
              ? "w-[90%] h-[3.5vw] px-[8%]"
              : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
          } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
        >
          <FontAwesomeIcon
            className="text-[#323232] text-[1.2vw] ml-[-2%]"
            icon={faBars}
          />
          {isExpanded && (
            <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
              Ascunde Meniu
            </span>
          )}
        </div>

        {menuItems.map(({ icon, label, page }, index) => (
          <div
            key={index}
            onClick={() => setCurrentPage(page)}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.5vw] px-[8%]"
                : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
            } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1.2vw] ml-[-2%]"
              icon={icon}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                {label}
              </span>
            )}
          </div>
        ))}
        <div
            onClick={() => openDutys()}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.5vw] px-[8%]"
                : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
            } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1.2vw] ml-[-2%]"
              icon={faStopwatch}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                Pontaje Active
              </span>
            )}
          </div>
        {menuItems2.map(({ icon, label, page }, index) => (
          <div
            key={index}
            onClick={() => setCurrentPage(page)}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.5vw] px-[8%]"
                : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
            } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1.2vw] ml-[-2%]"
              icon={icon}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                {label}
              </span>
            )}
          </div>
        ))}
        {isConducere === true && (
          <div
            onClick={() => setCurrentPage("treasury")}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.5vw] px-[8%]"
                : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
            } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1.2vw] ml-[-2%]"
              icon={faBank}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                Visterie
              </span>
            )}
          </div>
        )}
        <div
            onClick={() => setOpen(true)}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.5vw] px-[8%]"
                : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
            } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1.2vw] ml-[-2%]"
              icon={faPlus}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                Invită Membru
              </span>
            )}
        </div>
      </div>

      <div className="w-full mt-[20%] flex items-center justify-center">
        <div
          onClick={logOutUser}
          className={`${
            isExpanded
              ? "w-[90%] h-[3.5vw] px-[8%]"
              : "w-[3.5vw] h-[3.5vw] flex items-center justify-center"
          } min-h-[3vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
        >
          <FontAwesomeIcon
            className="text-[#323232] text-[1.2vw] ml-[-2%]"
            icon={faRightFromBracket}
          />
          {isExpanded && (
            <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
              Deconectează-te
            </span>
          )}
        </div>
      </div>
      <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
          backdrop: {
              timeout: 500
          },
          }}
      >
          <Fade in={open}>
          <Box sx={style} className="flex flex-col items-center">
              <span className=" text-white textSemiBold text-[1.2vw] w-full text-center">Invită membru în departament</span>
              <img className="w-[40%] mt-[1%] mb-[1%]" src={inviteMemberLogo} alt="" />
              <form action="submit" className="w-full h-[30%] flex flex-col items-center">
                <div className="w-full h-full flex items-center justify-center">
                  <Input
                    onChange={handleChangeMail}
                    startDecorator={<MailIcon />}
                    endDecorator={
                        <Button 
                        onClick={sendEmail}
                        sx={{
                            backgroundColor: '#D8630F', 
                            color: 'white',
                            '&:hover': { 
                            backgroundColor: 'darkorange', 
                            }
                        }}
                        >
                        Invita
                        </Button>
                    }
                    placeholder="Introdu email"
                    sx={{
                      "--Input-radius": "25px",
                      "--Input-gap": "10px",
                      "--Input-placeholderOpacity": 1,
                      "--Input-focusedThickness": "2px",
                      "--Input-minHeight": "50px",
                      "--Input-decoratorChildHeight": "38px",
                      "--Input-paddingInline": "10px",
                      backgroundColor: '#323232',
                      color: 'grey', 
                      borderColor: 'transparent',
                      borderWidth: '2px', 
                      outline: 'none',
                      width: '65%',
                      height: '40%',
                      '&:hover': { borderColor: '#D8630F' }, 
                      '&:focus': { borderColor: '#D8630F' }, 
                      '&::placeholder': {
                      color: 'grey',
                      },
                    }}
                  />
                </div>
              </form>
          </Box>
          </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={dutyModalOpen}
        onClose={handleCloseDutyModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        },
        }}
      >
        <Fade in={dutyModalOpen}>
        <Box sx={dutyStyle} className="flex flex-col">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">PONTAJE ACTIVE</span>
          <div className="w-[100%] h-[100%] flex flex-col items-center bg-[#323232] rounded-[.3vw]">
            <div className="h-[10%] w-[95%] flex items-center justify-center">
              <span onClick={() => openDutyModal("pol")} className="textSemiBold w-[50%] h-full flex items-center justify-center text-white text-[1vw]">Polițiști activi: <span className="textExtraBold text-[1.5vw] pl-[1%]">{activeCops.length} ({checkJaf(activeCops)})</span></span>
              <div className="w-[1px] h-[75%] bg-[#4c4c4c]"></div>
              <span onClick={() => openDutyModal("pen")} className="textSemiBold w-[50%] h-full flex items-center justify-center text-white text-[1vw]">Agenti-Pază activi: <span className="textExtraBold text-[1.5vw] pl-[1%]">{activePen.length}</span></span>
            </div>
            <div className="w-[95%] h-[1px] bg-[#4c4c4c]"></div>
            <div className="w-[95%] h-[99%] flex items-center justify-center">
              <div className="w-[50%] h-full flex-col">
                <span className="textSemiBold text-white text-[1vw] w-full h-[10%] flex items-center justify-center">Instructori Activi</span>
                <div className="w-[100%] h-[1px] bg-[#4c4c4c] flex flex-col"></div>
                <div className="w-full h-fit flex flex-col">
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Testeri: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "tester")}</span><div onClick={() => showActivityData("pol", "functions", "tester", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Instructor Radio: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "instructor radio")}</span><div onClick={() => showActivityData("pol", "functions", "instructor radio", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Instructor MDT: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "instructor MDT")}</span><div onClick={() => showActivityData("pol", "functions", "instructor MDT", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Instructor FTO: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "instructor FTO")}</span><div onClick={() => showActivityData("pol", "functions", "instructor FTO", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Instructor Pilot: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "instructor pilot")}</span><div onClick={() => showActivityData("pol", "functions", "instructor pilot", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Instructor Moto: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "instructor moto")}</span><div onClick={() => showActivityData("pol", "functions", "instructor moto", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[1%] flex">Instructor HS: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "instructor HS")}</span><div onClick={() => showActivityData("pol", "functions", "instructor HS", "regular")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                </div>
                <div className="w-[100%] h-[1px] bg-[#4c4c4c] flex flex-col mt-[2%]"></div>
                <div className="w-[100%] h-[34%] flex items-center justify-center">
                  <span className="text-white text-[1vw] textSemiBold w-[95%] text-wrap text-center">Callsign: {
                    regularCallsigns.map((member, index) => (
                      <span key={index} className="textExtraBold text-[1vw]">{String(member.callsign).padStart(3, '0')}{index !== regularCallsigns.length - 1 ? ', ' : ''}</span>
                    ))
                  }</span>
                </div>
              </div>
              <div className="w-[1px] h-[95%] bg-[#4c4c4c]"></div>
              {(isConducere2 || isHR) ? (
                <div className="w-[50%] h-full flex flex-col">
                  <span className="textSemiBold text-white text-[1vw] w-full h-[10%] flex items-center justify-center">Sub-Departamente</span>
                  <div className="w-[100%] h-[1px] bg-[#4c4c4c] flex flex-col"></div>
                  <div className="w-full h-fit flex flex-col">
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">Resurse Umane: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "resurse umane")}</span><div onClick={() => showActivityData("pol", "functions", "resurse umane", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">Relatii Publice: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "relatii publice")}</span><div onClick={() => showActivityData("pol", "functions", "relatii publice", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">Frontiera: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "frontiera")}</span><div onClick={() => showActivityData("pol", "functions", "frontiera", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">Moto: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("certificates", "moto")}</span><div onClick={() => showActivityData("pol", "certificates", "moto", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">Pilot: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("certificates", "pilot")}</span><div onClick={() => showActivityData("pol", "certificates", "pilot", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">HS: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("certificates", "high-speed")}</span><div onClick={() => showActivityData("pol", "certificates", "high-speed", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">D.I.S: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "DIS")}</span><div onClick={() => showActivityData("pol", "functions", "DIS", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">T.A.T: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "trupele anti-tero")}</span><div onClick={() => showActivityData("pol", "functions", "trupele anti-tero", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                    <span className="w-[100%] text-white text-[.9vw] textSemiBold mt-[2%] pl-[2%] flex">PCLS: <span className="textExtraBold text-[1vw] ml-[1%]">{countCops("functions", "PCLS")}</span><div onClick={() => showActivityData("pol", "functions", "PCLS", "hr")} className="ml-[2%] w-[8%] bg-gradient-to-r from-[#319BC1] to-[#193989] cursor-pointer flex items-center justify-center rounded-[.3vw] shadow-xl"><FontAwesomeIcon fontSize={17} icon={faList} /></div></span>
                  </div>
                  <div className="w-[100%] h-[1px] bg-[#4c4c4c] flex flex-col mt-[2%]"></div>
                  <div className="w-[100%] h-[19%] flex items-center justify-center">
                    <span className="text-white text-[1vw] textSemiBold w-[95%] text-wrap text-center">Callsign: {
                      HRCallsigns.map((member, index) => (
                        <span key={index} className="textExtraBold text-[1vw]">{String(member.callsign).padStart(3, '0')}{index !== HRCallsigns.length - 1 ? ', ' : ''}</span>
                      ))
                    }</span>
                  </div>
                </div>
              ) : (
                <span className="w-[50%] h-full flex items-center justify-center text-white textSemiBold text-[1vw]">Nu ai acces la această funcție!</span>
              )}
            </div>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={allDutyOpen}
        onClose={handleAllDutyClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={allDutyOpen}>
          <Box sx={activeDutyStyle} className="flex flex-col">
            <span className="text-white textSemiBold text-[1vw] w-full text-center">LISTA PONTAJE ACTIVE - {activeDutyType === "pol" ? "POLIȚIE": "PENITENCIAR"}</span>
            <div className="w-[100%] h-full  bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%] overflow-y-scroll">
            {openDuties.map((duty, index) => (
              <div key={index} className="w-full min-h-[14%] overflow-y-scroll border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]">
                <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{duty.type === "pol" ? `${String(duty.callsign).padStart(3, '0')}` : `P-${String(duty.callsign).padStart(2, '0')}`}</span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{duty.type === "pol" ? `${getPoliceMemberInfo(duty.callsign, "full_name")}` : `${getPenMemberInfo(duty.callsign, "full_name")}`}</span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                {duty.inTest && duty.inTest !== "null" && (
                  <>
                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{duty.inTest}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  </>
                )}
                <span className="textSemiBold min-w-fit text-center  text-[0.9vw] text-[#ffffff]">Deschis la: {String(duty.start_clock)}</span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                {(isConducere2 || isHR) && (
                  <div
                    onClick={() => cancelDuty(duty.callsign, duty.type)}
                    className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]"
                  >
                    <span className="textBold text-white text-[.8vw]">ANULEAZĂ PONTAJ</span>
                  </div>
                )}
              </div>
            ))}
            </div>
          </Box>
        </Fade>
      </Modal>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  );
};

export default Sidebar;